var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":"Ocupação - CBO","type":"fieldset"}},[_c('Form',{attrs:{"data":_vm.data}}),_c('List',{attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }